import { useEffect, useState } from 'react';
import apiClient from '../api/client';

export const useAutomationStats = () => {
  const [stats, setStats] = useState(null);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('auth_token');
    console.log('📊 Calling fetch for automation stats');

    apiClient.get('/automations/stats', {
      headers: {
        Authorization: `Bearer ${token}`
      }
    })
      .then(res => {
        setStats(res.data);
      })
      .catch(err => {
        if (err.response?.status === 401) {
          console.warn('401 received — likely due to early render');
        } else {
          console.error('Error fetching automation stats:', err);
          setError(err);
        }
      })
      .finally(() => setIsLoading(false));
  }, []);

  return { stats, error, isLoading };
};